import { IProductNew } from 'interfaces/product';
import { IChat } from 'interfaces/script';
import { BehaviorSubject } from 'rxjs';

import apiService, { ApiService } from './api';

export class ChatService {
  private selectedProductChat$ = new BehaviorSubject<IProductNew>(null);
  private selectedChat$ = new BehaviorSubject<IChat>(null);

  constructor(private api: ApiService) {}

  public saveChat() {
    const selectedProduct = this.selectedProductChat$.value;
    const chat = this.selectedChat$.value;

    if (selectedProduct.chat) {
      return this.api.put(`/chat/${selectedProduct.id}`, chat);
    }

    return this.api.post(`/chat/${selectedProduct.id}`, chat);
  }

  public setSelectedChat(chat: IChat) {
    this.selectedChat$.next(chat);
  }

  public setSelectedProductsChat(product: IProductNew) {
    if (product.chat) {
      this.loadChat(product.id);
    }

    this.selectedChat$.next({ type: '', key: '', active: true });
    this.selectedProductChat$.next(product);
  }

  public unselectProductChat() {
    this.selectedProductChat$.next(null);
  }

  public unselectChat() {
    this.selectedChat$.next(null);
  }

  public getSelectedProductChat() {
    return this.selectedProductChat$.asObservable();
  }

  public getSelectedChat() {
    return this.selectedChat$.asObservable();
  }

  private loadChat(idProduct: number) {
    this.api.get(`/chat/${idProduct}`).subscribe(chat => this.selectedChat$.next(chat));
  }
}

export const ChatServiceFactory = () => new ChatService(apiService);

export const chatService = ChatServiceFactory();
